<script setup lang="ts">
import CogButton from "@/components/header/CogButton.vue";
import DocumentationButton from "@/components/header/DocumentationButton.vue";
</script>

<template>
  <v-app-bar class="pa-0" height="48" app fixed dark v-bind="$attrs">
    <v-toolbar v-bind="$attrs" density="compact" color="secondary" style="width: 100%">
      <CogButton />
      <div
        class="d-flex justify-center align-center"
        style="position: absolute; left: 50%; transform: translateX(-50%)"
      >
        <div class="d-flex justify-center align-center">
          <div>
            <v-img
              alt="Logo"
              class="shrink"
              src="/assets/haskoning-logo-white.svg"
              contain
              transition="scale-transition"
              width="30"
              v-bind="$attrs"
            />
          </div>
          <v-toolbar-title class="app-title ml-2">EQUATION</v-toolbar-title>
        </div>
      </div>

      <v-spacer />
      <DocumentationButton />
    </v-toolbar>
  </v-app-bar>
</template>

<style scoped>
:deep(.v-toolbar__extension) {
  padding: 0 !important;
}
</style>
